import { IndicatorType } from '../constants/common'
import { FICalculation } from '../indicator-calculation/fi'
import Indicator from './indicator'

interface Attrs {
  period: string
}

class ForceIndex extends Indicator<Attrs> {
  static type = IndicatorType.Fi
  static label = 'Force Index'

  fiCalculation: FICalculation | null = null
  declare period: number

  set(values: Partial<Attrs>) {
    super.set(values)
    this.parsePeriodInt(values)
  }

  compute() {
    if (this.isComputeNecessary()) {
      this.fiCalculation = new FICalculation({
        quote: this.data,
        options: {
          period: this.period,
        },
      })
      this.fiCalculation.calculate()
      this.lastValue = this.fiCalculation.calculatedValues.fi.last() ?? null
    }
    const fi = this.fiCalculation?.calculatedValues.fi ?? []
    const { min, max } = fi.length > 0 ? this.computeVisibleMinMax(fi) : this.getDomainDefaults(this.type)
    this.min = min
    this.max = max
  }

  renderIndicator(context: CanvasRenderingContext2D) {
    this.renderOversoldOverbought(context, this.fiCalculation?.calculatedValues.fi ?? [], 1, 0, 0, 0, false)
  }

  getModalConfig() {
    const period = {
      type: 'number',
      label: 'Period',
      name: 'period',
      value: this.period ?? 13,
      required: true,
      min: 1,
      max: 999999,
    }

    return {
      title: this.label,
      inputs: [period],
      inputsErrorMessages: {
        period: `${period.label} must be a whole number between ${period.min} and ${period.max}`,
      },
    }
  }

  getIsValid(key: string): boolean {
    switch (key) {
      case 'period':
        return this.getIsNumberInputValid({ key })
      default:
        return false
    }
  }

  toString() {
    return `FORCE ${this.period}`
  }
}

export default ForceIndex
